<ng-container *ngIf="model">
  <u-icon class="browser-tab-item-icon" [model]="modelIcon" [styles]="{ fontSize: '20px', width: '20px', height: '20px' }"></u-icon>
  <div class="content-container">
    <div class="title-container">
      <result-title [model]="{ text: model.title }" [selected]="selected" [highlights]="model.highlights"> </result-title>
    </div>
    <div class="subtitle-container">
      <div class="profile-indicator" *ngIf="showProfileIndication">
        <u-icon
          class="profile-picture"
          [model]="profilePicture"
          [styles]="{ backgroundSize: 'contain', width: '14px', height: '14px', borderRadius: '50%' }"
          *ngIf="profilePicture; else default"
        ></u-icon>
        <ng-template #default>
          <avatar [size]="'14px'" [url]="MEMBER_ICON_FALLBACK"></avatar>
        </ng-template>
        <p class="profile-name">{{ model.profile?.name }}</p>
      </div>
      <div class="dot" *ngIf="showProfileIndication"></div>
      <result-subtitle [model]="{ text: model.url, tooltip: model.url }" [highlights]="model.highlights"> </result-subtitle>
      <div class="dot"></div>
      <p class="time-ago">{{ timeAgo }}</p>
    </div>
  </div>
  <div class="message">
    <u-icon class="message-icon" [model]="{ type: 'font', value: 'icon-cards' }" [styles]="{ width: '16px', height: '16px' }"></u-icon>
    <p class="message-text">Switch to this tab</p>
  </div>
</ng-container>
